import { render, staticRenderFns } from "./InvoiceLabelDialog.vue?vue&type=template&id=6cdcddfb&"
import script from "./InvoiceLabelDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceLabelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports